import {useSideBarModal} from '../../../../../layout/common/useSideBarModal';
import React, {useCallback, useMemo} from 'react';
import ModelEditFilesSideBarModal from './ModelEditFilesSideBarModal';
import ModelEditFilesSideBarModalRedesigned from './ModelEditFilesSideBarModalRedesigned';
import SideBarModal from '../../../../../layout/common/SideBarModal';
import {ModelActionProps} from '../../../../actionMenuTypes';

export const useModelEditFilesSideBarModal = (props: Partial<ModelActionProps>) => {
  const {model, onSuccess, newDesign} = props;
  const {buttonRef, openModal, closeModal} = useSideBarModal(model?.uuid);
  const handleSuccess = useCallback(() => {
    closeModal();
    onSuccess?.();
  }, [closeModal, onSuccess]);

  const ModalComponent = useMemo(() => {
    return (
      model && (
        <SideBarModal className="whiteTheme" isOpen={!!buttonRef} buttonRef={buttonRef} closeModal={closeModal}>
          <div style={{width: '80rem'}}>
            {!!buttonRef && (
              <>
                {newDesign ? (
                  <ModelEditFilesSideBarModalRedesigned model={model} onSuccess={handleSuccess} onCancel={closeModal} />
                ) : (
                  <ModelEditFilesSideBarModal model={model} onSuccess={handleSuccess} onCancel={closeModal} />
                )}
              </>
            )}
          </div>
        </SideBarModal>
      )
    );
  }, [buttonRef, closeModal, handleSuccess, model, newDesign]);

  return {
    openModal,
    ModalComponent,
  };
};
